import * as React from "react";
const SvgGridExtension20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 1h2.2v2H9V1ZM8 5h3.04l-2 2H9v4h4v-.04l2-2V19H1V5h7Zm9 6V8.8h2V11h-2ZM1 1h2.5v2H1V1Zm8 12h4v4H9v-4Zm-2-2V7H3v4h4Zm0 2v4H3v-4h4Zm10 3.5V19h2v-2.5h-2Zm0-1.5v-2.5h2V15h-2ZM5 1h2.5v2H5V1Zm9 0h-1v2h2.586l-3.793 3.793-.707.707L12.5 8.914l.707-.707L17 4.414V7h2V1h-5Z",
      clipRule: "evenodd"
    })
  );
export default SvgGridExtension20Px;
